module.exports = __webpack_public_path__ + "static/media/addBtn.f513c633.png";